// extracted by mini-css-extract-plugin
export default {"fadeBackground":"events_home_page__fadeBackground__r6d18"};